export default __webpack_public_path__ + "static/media/img-0483-andorra-full-face.72650914.png";